export interface BatchInjectLocationInJobRequest{
    PlanId: string;
    ConnectionId: string;
}